import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client';
import { getEarlyRequestResult } from '../utils/earlyRequest';
const fetchSeatsInventory = () => http.get('/monetization/v3/seats/inventory');
export const GET_SEATS_INVENTORY = registerQuery({
  fieldName: 'seatsInventory',
  args: ['earlyRequestName'],
  fetcher({
    earlyRequestName
  }) {
    return getEarlyRequestResult(earlyRequestName, fetchSeatsInventory);
  }
});